import React from 'react';
import Lessons from '../components/Lessons';
import Pageheader from '../utils/headerHelment';

const LessonsView = () => {
    return (
        <>
            <Pageheader title="LENS - Lessons Learnt" />
            <Lessons />
        </>
    );
};

export default LessonsView;


